export default __webpack_public_path__ + "static/media/Bloodseer's Gloves.55a59b72.jpg";